import React from 'react';
import './Differentiators.css';

const Differentiators = () => {
  const differentiators = [
    {
      icon: '✨',
      title: 'IA y Automatización',
      description: 'Simplificamos la creación de modelos de negocio con inteligencia artificial'
    },
    {
      icon: '🎯',
      title: 'Enfoque Integral',
      description: 'Desde la idea hasta el desarrollo digital y la analítica de datos'
    },
    {
      icon: '📊',
      title: 'Soluciones Escalables',
      description: 'Para emprendedores y empresas en distintas etapas de crecimiento'
    },
    {
      icon: '🤝',
      title: 'Comunidad y Formación',
      description: 'Impulsamos el ecosistema emprendedor con formación continua'
    }
  ];

  return (
    <section className="differentiators">
      <div className="differentiators-container">
        <div className="section-header">
          <h2 className="section-title">¿Por Qué Elegirnos?</h2>
          <p className="section-subtitle">
            Diferenciadores que nos hacen únicos
          </p>
        </div>

        <div className="differentiators-grid">
          {differentiators.map((item, index) => (
            <div key={index} className="differentiator-card">
              <div className="differentiator-icon">{item.icon}</div>
              <h3 className="differentiator-title">{item.title}</h3>
              <p className="differentiator-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Differentiators;

